/*
=========================================================
3BroCases Premium UI Kit
Live Sales Popup V2
Part 1
=========================================================
*/

document.addEventListener("DOMContentLoaded", () => {

const popup=document.getElementById("pyv-sales-popup");

if(!popup)return;

const image=document.getElementById("pyv-popup-image");
const customer=document.getElementById("pyv-popup-customer");
const action=document.getElementById("pyv-popup-action");
const product=document.getElementById("pyv-popup-product");
const price=document.getElementById("pyv-popup-price");
const time=document.getElementById("pyv-popup-time");
const progress=document.getElementById("pyv-progress-bar");
const closeBtn=document.getElementById("pyv-popup-close");

const raw=document.getElementById("pyv-products-data");

if(!raw)return;

let products=JSON.parse(raw.textContent);

if(!products.length)return;

products=products.filter(
p=>p.handle!==window.pyvPopupConfig.currentProduct
);

if(!products.length)return;

/* -----------------------
Indian Names
------------------------ */

const names=[

"Rahul S.","Priya K.","Aman P.","Sneha R.","Arjun M.",
"Neha G.","Rohit T.","Simran K.","Aditi P.","Karan V.",
"Harsh P.","Ayush R.","Ishita M.","Ankit S.","Riya T.",
"Vivek G.","Pooja K.","Sahil J.","Muskan A.","Nikhil D.",
"Dev P.","Yash R.","Megha K.","Parth S.","Rohan P.",
"Shruti G.","Akash T.","Sonia R.","Varun K.","Tanvi M.",
"Anjali P.","Deepak S.","Kriti V.","Manav R.","Nitin J.",
"Bhavna K.","Aryan M.","Payal S.","Sagar P.","Komal T."

];

/* -----------------------
Cities
------------------------ */

const cities=[

"Mumbai",
"Pune",
"Delhi",
"Bengaluru",
"Hyderabad",
"Ahmedabad",
"Jaipur",
"Surat",
"Lucknow",
"Chennai",
"Indore",
"Kolkata",
"Nagpur",
"Bhopal",
"Patna",
"Kanpur",
"Kochi",
"Vadodara",
"Nashik",
"Goa"

];

/* -----------------------
Actions
------------------------ */

const actions=[

"just grabbed",

"ordered",

"picked",

"recently bought",

"checked out",

"loved",

"added to collection",

"couldn't resist",

"just purchased"

];

/* -----------------------
Times
------------------------ */

const times=[

"Just now",

"2m ago",

"4m ago",

"6m ago",

"8m ago",

"12m ago",

"18m ago",

"26m ago",

"31m ago"

];

let queue=[];

function shuffle(arr){

const a=[...arr];

for(let i=a.length-1;i>0;i--){

const j=Math.floor(Math.random()*(i+1));

[a[i],a[j]]=[a[j],a[i]];

}

return a;

}

function refill(){

queue=shuffle(products);

}

refill();/* -----------------------
Helpers
------------------------ */

function pick(arr){

return arr[Math.floor(Math.random()*arr.length)];

}

function nextProduct(){

if(queue.length===0){

refill();

}

return queue.shift();

}

let timer=null;

let hiddenTimer=null;


/* -----------------------
Render Popup
------------------------ */

function render(){

const item=nextProduct();

customer.textContent=

pick(names)+" • "+pick(cities);

action.textContent=

pick(actions);

product.textContent=

item.title;

price.textContent=

item.price;

time.textContent=

pick(times);

image.src=item.image;

image.alt=item.title;

popup.onclick=()=>{

window.location.href=item.url;

};

progress.style.animation="none";

progress.offsetHeight;

progress.style.animation=

"pyvProgress "+(window.pyvPopupConfig.duration/1000)+"s linear forwards";

popup.style.display="block";

requestAnimationFrame(()=>{

popup.classList.add("show");

});

hiddenTimer=setTimeout(()=>{

popup.classList.remove("show");

setTimeout(()=>{

popup.style.display="none";

},450);

},window.pyvPopupConfig.duration);

}


/* -----------------------
Loop
------------------------ */

function startLoop(){

render();

const nextDelay=

window.pyvPopupConfig.delay+

Math.floor(Math.random()*6000);

timer=setTimeout(startLoop,nextDelay);

}


/* -----------------------
Close
------------------------ */

closeBtn.addEventListener("click",(e)=>{

e.stopPropagation();

popup.classList.remove("show");

setTimeout(()=>{

popup.style.display="none";

},350);

clearTimeout(hiddenTimer);

});


/* -----------------------
Pause on Hover
------------------------ */

popup.addEventListener("mouseenter",()=>{

clearTimeout(hiddenTimer);

clearTimeout(timer);

});

popup.addEventListener("mouseleave",()=>{

hiddenTimer=setTimeout(()=>{

popup.classList.remove("show");

setTimeout(()=>{

popup.style.display="none";

},350);

},1200);

timer=setTimeout(startLoop,window.pyvPopupConfig.delay);

});


/* -----------------------
Preload Next Image
------------------------ */

function preload(){

if(queue.length===0)return;

const img=new Image();

img.src=queue[0].image;

}

setInterval(preload,5000);


/* -----------------------
Start
------------------------ */

setTimeout(startLoop,3000);

});